module.exports = __webpack_public_path__ + "media/assets/images/blog/property_of-5fb35ffce6e9743e8bb9a96d634f1cc3.png";